import React from 'react'; // eslint-disable-line
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _actions from '../../actions';
import '../../assets/styles/master.css';
import YesNoDialog from '../common/YesNoDialog';
import i18n from '../../i18n';
import Recrop from '../svg/Recrop';
import DeleteX from '../svg/DeleteX';

class LogoSecondStep extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;

        this.state = {
            deleteConfirmationDialogOpened: false,
        };
        this.closeDeleteConfirmationDialog = this.closeDeleteConfirmationDialog.bind(this);
        this.deleteImages = this.deleteImages.bind(this);
    }

    onDeleteButtonClick() {
        const stateObj = {};
        stateObj.deleteConfirmationDialogOpened = true;
        this.setState(stateObj);
    }

    onRecropButtonClick() {
        this.recropImage();
    }

    deleteImages() {
        this.props.actions.deleteImagesForCropForCrop(
            this.props.versions.select.projectId, this.props.imageType, '00000000-0000-0000-0000-000000000000',
        );
    }

    recropImage() {
        this.props.actions.getOriginalImageForCrop(
            this.props.versions.select.projectId, this.props.imageType, '00000000-0000-0000-0000-000000000000',
        );
    }

    closeDeleteConfirmationDialog() {
        const stateObj = {};
        stateObj.deleteConfirmationDialogOpened = false;
        this.setState(stateObj);
    }

    render() {
        return (
            <div className="choosing-size">
                <div className="action-items">
                    <h2
                        id="logo-subhead"
                        data-qa="logo-page-two-header"
                    >
                        {i18n.t('logo2.title')}
                    </h2>
                    <ul className="actions">
                        <li>
                            {/* eslint-disable-next-line */}
                            <a
                                id="recrop-button"
                                data-qa="logo-page-two-recrop-button"
                                onClick={() => { return this.onRecropButtonClick(); }}
                            >
                                <Recrop />
                                {i18n.t('crop')}
                            </a>
                        </li>
                        <li>
                            {/* eslint-disable-next-line */}
                            <a
                                id="delete-button"
                                data-qa="logo-page-two-delete-button"
                                onClick={() => { return this.onDeleteButtonClick(); }}
                            >
                                <DeleteX />
                                {i18n.t('delete')}
                            </a>
                        </li>
                    </ul>
                </div>
                <div
                    id="preview-logo-image"
                    data-qa="logo-page-two-image-wrapper"
                    className="preview logo-cropped-preview"
                >
                    {typeof this.props.imagePath !== 'undefined' && this.props.imagePath !== null
                    && (
                        <img
                            alt=""
                            src={`${this.props.imagePath}`}
                            style={{
                                maxWidth: '240px',
                                maxHeight: '166px',
                            }}
                        />
                    )}
                </div>
                <YesNoDialog
                    Message={i18n.t('logo2.delete')}
                    ExecuteAction={this.deleteImages}
                    CloseDialog={this.closeDeleteConfirmationDialog}
                    Visible={this.state.deleteConfirmationDialogOpened}
                    DataQA="logo-page-2-delete-modal"
                />
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...state,
        versions: state.versions,
        ...ownProps,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(_actions, dispatch),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(LogoSecondStep);
